<h2 mat-dialog-title>Acord Form</h2>

<h3 mat-dialog-title>Have an Acord Form ? Upload Here</h3>

<div class="upload-document-container bg-white rounded">
    <div class="row mx-6 my-5 g-0"> 
        <div class="dropzone dz-clickable  px-6">
            <div class="d-flex dz-message needsclick">
                <i class="bi bi-file-earmark-text bi-container"></i>
                <div class="ms-4 text-start">
                    <h3 class="fs-4 fw-bold text-gray-900 mb-1">Drag your Supporting file(s) or <a>browse</a></h3>
                    <span class="fw-semibold fs-7 text-muted">Only support .pdf, .docx within 2mb</span>
                </div>
            </div>
        </div>      
    </div>
</div>

<h3 mat-dialog-title>Dont't have an Acord Form ? No Worries, You can enter manually</h3>

<mat-dialog-actions>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="RequestQuote()">Request Quote</button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="RequestQuote()">Upload Acord Form </button>
  <button mat-button type="button" class="btn btn-lg btn-primary continue-btn" (click)="RequestQuote()">Proceed without Acord </button>
</mat-dialog-actions>